import { graphql } from './client';

const MUTATION = `
    mutation RecordMfaEnrolment {
        recordMfaEnrolment {
            enabledAt
        }
    }
`;

// Records the date of first MFA compliance, an event and not a state. Failure is swallowed
// on purpose: the factor is registered in the pool whatever this call does.
export const recordMfaEnrolment = (idToken: string): void => {
    void graphql(MUTATION, undefined, idToken).catch(() => {});
};
